import Vue from 'vue'

// 注册一个全局自定义指令 `v-auto-height`
Vue.directive('auto-height', {
  bind(el) {
    let min_height = $(window).height() - 210
    $(el).css({ 'min-height': min_height + 'px' })
  }
})
